import { CommitteeModel } from "@api/models/committees/CommitteeModel";
import { committeeConverter } from "@api/models/objects/Converters";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { QueryBuilderInterface } from "@share/common/types/interfaces/api/QueryBuilerInterface";
import { ListLoaderInterface } from "@share/common/types/interfaces/list/ListLoaderInterface";
import { FilteringParams } from "@share/committees/committees-list/types/FilteringParams";
import Axios, { CancelTokenSource } from "axios";

export class CommitteesListService implements ListLoaderInterface<CommitteeModel> {
    constructor(
        private readonly queryBuilder: QueryBuilderInterface,
        private readonly objectRepository: ObjectRepository,
        private readonly schemaId: string
    ) {
    }

    cancelToken?: CancelTokenSource;

    async load(filterState: FilteringParams) {

        if (this.cancelToken) {
            this.cancelToken.cancel();
        }

        let query = this.queryBuilder.getQuery(filterState);

        this.cancelToken = Axios.CancelToken.source();

        const { data, count } = await this.objectRepository.queryWithCount<CommitteeModel[]>(
            this.schemaId,
            query,
            committeeConverter,
            {
                cancelToken: this.cancelToken.token
            }
        );

        this.queryBuilder.setCount(count);

        return data;
    }

    /**
     * delete concrete committee
     * @param committeeId
     * @returns
     */
    delete(committeeId: string) {
        return this.objectRepository.delete(this.schemaId, [committeeId]);
    }
}
